<template>
    <rkm-area
        title="Agendamento"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.obrigaMotivoAgendamentoExcedente">
                    Obriga motivo para agendamento excedente
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.avisaCnsProvisorio">
                    Exibe aviso de CNS provisório
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.avisaPacienteOutraUnidade">
                    Exibe aviso de paciente de outra unidade
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.bloqueiaPacienteTemporario">
                    Bloqueia paciente temporário
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    props: {
        data: {required: true, type: Object},
    },
}
</script>